export const CONTRACTUAL_CATEGORIES_TYPE_BUSINESS = 'BUSINESS';
export const CONTRACTUAL_CATEGORIES_TYPE_PRIVATE = 'PRIVATE';

export const CONTRACTUAL_CATEGORIES_TYPES_TAG_MAP = {
  'P.IVA': CONTRACTUAL_CATEGORIES_TYPE_BUSINESS,
  'Privati': CONTRACTUAL_CATEGORIES_TYPE_PRIVATE,
}

export const CONTRACTUAL_CATEGORIES = [
  {
    description: 'Dipendente a tempo indeterminato',
    value: 'tempo-indeterminato',
    type: CONTRACTUAL_CATEGORIES_TYPE_PRIVATE,
    secondaryType: CONTRACTUAL_CATEGORIES_TYPE_PRIVATE,
  },
  {
    description: 'Ditta individuale',
    value: 'ditta-individuale',
    type: CONTRACTUAL_CATEGORIES_TYPE_BUSINESS,
    secondaryType: CONTRACTUAL_CATEGORIES_TYPE_PRIVATE,
  },
  {
    description: 'Libero professionista',
    value: 'libero-professionista',
    type: CONTRACTUAL_CATEGORIES_TYPE_BUSINESS,
    secondaryType: CONTRACTUAL_CATEGORIES_TYPE_PRIVATE,
  },
  {
    description: 'Pensionato',
    value: 'pensionato',
    type: CONTRACTUAL_CATEGORIES_TYPE_PRIVATE,
    secondaryType: CONTRACTUAL_CATEGORIES_TYPE_PRIVATE,
  },
  {
    description: 'Società di capitali (S.p.a. - S.r.l. - S.r.l.s. - S.a.p.a. - Cooperative)',
    value: 'societa-capitale',
    type: CONTRACTUAL_CATEGORIES_TYPE_BUSINESS,
    secondaryType: CONTRACTUAL_CATEGORIES_TYPE_BUSINESS,
  },
  {
    description: 'Società di persone (S.s. - S.n.c. - S.a.s.)',
    value: 'societa-persone',
    type: CONTRACTUAL_CATEGORIES_TYPE_BUSINESS,
    secondaryType: CONTRACTUAL_CATEGORIES_TYPE_BUSINESS,
  },
  {
    description:
      'Associazioni - Enti - Fondazioni',
    value: 'associazioni-enti-fondazioni',
    type: CONTRACTUAL_CATEGORIES_TYPE_BUSINESS,
    secondaryType: CONTRACTUAL_CATEGORIES_TYPE_BUSINESS,
  },
  {
    description: 'Studi Associati',
    value: 'studi-associati',
    type: CONTRACTUAL_CATEGORIES_TYPE_BUSINESS,
    secondaryType: CONTRACTUAL_CATEGORIES_TYPE_BUSINESS,
  },
];

export const FRANCHISE_KASKO = [
  {
    description: '500€',
    value: 500,
  },
  {
    description: '250€',
    value: 250,
  },
  {
    description: '150€',
    value: 150,
  },
  {
    description: '0€',
    value: 0,
  },
];
export const FRANCHISE_INSURANCE = [
  {
    description: '10%',
    value: 10,
  },
  {
    description: '0%',
    value: 0,
  },
];
